module.exports = __webpack_public_path__ + "static/ForThePeople2-0e820b078719ff969671d092b11445f8.webp";